.container {
  display: grid;
  grid-template-columns: 124px 1fr;
  padding-right: 17px;
  padding-left: 17px;
  margin-right: auto;
  margin-left: auto;
  font-size: 14px;
  line-height: 1.8;
}

.link {
  color: rgb(0 0 0 / 70%);
  text-decoration: underline;
}

.pressReleaseRoot {
  @container press-release-root (min-width:1024px) {
    grid-template-columns: 166px 1fr;
    column-gap: 26px;
    max-width: unset;
    margin-bottom: auto;
    font-size: 15px;
    font-weight: 300;
    line-height: 1.7;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    grid-template-columns: 166px 1fr;
    column-gap: 26px;
    max-width: unset;
    margin-bottom: auto;
    font-size: 15px;
    font-weight: 300;
    line-height: 1.7;
  }
}
